import { render } from "./RoleConflictPage.vue?vue&type=template&id=2da2536d&ts=true"
import script from "./RoleConflictPage.ts?vue&type=script&lang=ts&external"
export * from "./RoleConflictPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__